import axios from 'axios';
import Cookies from 'js-cookie';

const API = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8001';

/**
 * Get axios config with auth token
 */
const getAuthConfig = () => {
  const token = Cookies.get('enakid_token');
  return {
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    }
  };
};

/**
 * Determine user type based on affiliate and business plan status
 * @param {string} userId - User ID
 * @returns {Promise<string>} - 'affiliateOnly', 'hybrid', 'businessOnly', or 'new'
 */
export const getUserType = async () => {
  try {
    const config = getAuthConfig();
    console.log('getUserType: Starting user type check...');
    
    // Check for affiliate record
    let hasAffiliate = false;
    try {
      const affiliateResponse = await axios.get(`${API}/api/affiliates/dashboard`, config);
      hasAffiliate = affiliateResponse.data && affiliateResponse.data.affiliate;
      console.log('getUserType: Affiliate check result:', hasAffiliate);
    } catch (error) {
      // 404 means no affiliate record, which is fine
      if (error.response?.status !== 404) {
        console.log('getUserType: Affiliate check error:', error.message);
      }
      hasAffiliate = false;
    }

    // Check for business plan
    let hasBusinessPlan = false;
    try {
      const businessResponse = await axios.get(`${API}/api/business-plans`, config);
      hasBusinessPlan = businessResponse.data && businessResponse.data.length > 0;
      console.log('getUserType: Business plan check result:', hasBusinessPlan, 'count:', businessResponse.data?.length);
    } catch (error) {
      // Error checking business plans
      if (error.response?.status !== 404) {
        console.log('getUserType: Business plan check error:', error.message);
      }
      hasBusinessPlan = false;
    }

    // Determine user type
    let userType = 'new';
    if (hasAffiliate && hasBusinessPlan) userType = 'hybrid';
    else if (hasAffiliate && !hasBusinessPlan) userType = 'affiliateOnly';
    else if (!hasAffiliate && hasBusinessPlan) userType = 'businessOnly';
    
    console.log('getUserType: Final user type:', userType);
    return userType;
  } catch (error) {
    console.error('getUserType: Error determining user type:', error);
    return 'new';
  }
};

/**
 * Get default route based on user type
 * @param {string} userType - User type from getUserType()
 * @returns {string} - Default route path
 */
export const getDefaultRoute = (userType) => {
  switch (userType) {
    case 'hybrid':
      return '/dashboard'; // Business takes priority
    case 'affiliateOnly':
      return '/affiliate';
    case 'businessOnly':
      return '/dashboard';
    case 'new':
    default:
      return '/dashboard';
  }
};
